module.exports = __webpack_public_path__ + "img/whatsapp.22bd2f9a.svg";